module.exports = __webpack_public_path__ + "static/media/AttendedFive.53cdc5e0.png";